import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ProductoService {

  constructor(private config: ConfigService,
    private http: HttpClient) { }

  // get acetegroization nivel 1
  getCategorizacionNivel1(token: string) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/CategoriaNivel1";
    return this.http.get(url, requestOptions);
  }

  // get acetegroization nivel N
  getCategorizacionNivelN(token: string, idCategoriaM: number) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/CategoriaNivelN/" + idCategoriaM;
    return this.http.get(url, requestOptions);
  }

  /// categorización de productos p0ra realización de la cotización
  getCategorizacion(token: string) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/Categorizacion";
    return this.http.get(url, requestOptions);
  }

  /*  getCategoria(token: string, idProveedor: number) {
     const requestOptions: object = {
       //headers: new Headers().set('responseType', 'text')
       headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
     }
     const url = this.config.urlService + "api/Producto/Categorias" + "/" + idProveedor;
     return this.http.get(url, requestOptions);
   } */

  setCategoriaNivelN(token: string, data: any) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/CategoriaNivelN";
    return this.http.post(url, data, requestOptions);
  }

  setInfoSEO(token: string, data: any) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'text'
    }
    const url = this.config.urlService + "api/Producto/setSEO";
    return this.http.post(url, data, requestOptions);
  }


  /*  getSubCategoria(token: string, idCategoria: number) {
     const requestOptions: object = {
       //headers: new Headers().set('responseType', 'text')
       headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
     }
     const url = this.config.urlService + "api/Producto/SubCategorias/" + idCategoria;
     return this.http.get(url, requestOptions);
   } */

  /* setSubCategoria(token: string, data: any) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/SubCategorias";
    return this.http.post(url, data, requestOptions);
  } */

  getUbicaciones(token: string, idProveedor: number) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/Ubicaciones/" + idProveedor;
    return this.http.get(url, requestOptions);
  }

  getEstadoFisico(token: string, idProveedor: number) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/EstadoFisico/" + idProveedor;
    return this.http.get(url, requestOptions);
  }


  getEstadoProductos(token: string) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/EstadoProducto";
    return this.http.get(url, requestOptions);
  }

  getCaracteristicas(token: string) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/Caracteristicas";
    return this.http.get(url, requestOptions);
  }



  searchSKU(token: string, identificador: string) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/" + identificador;
    return this.http.get(url, requestOptions);
  }

  setSKU(token: string, data: object) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/Crear";
    return this.http.post(url, data, requestOptions);
  }

  /**
   * Fijar atributos como alto ancho y longitud y peso de cada producto
   * @param token 
   * @param data 
   * @returns 
   */
  setAtributos(token: string, data: object) {
    const requestOptions: object = {
      //headers: new Headers().set('responseType', 'text')
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Producto/AtributoAdd";
    return this.http.post(url, data, requestOptions);
  }

  setCaracteristicas(token: string, data: Array<object>) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const url = this.config.urlService + "api/Producto/Caracteristica";
    return this.http.post(url, data, { headers, responseType: 'text' });
  }

  setPhotos(token: string, data: any, idProveedor: number, idProducto: number, orden: number) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const url = this.config.urlService + "api/Producto/Image/" + idProveedor + "/" + idProducto + "/" + orden;
    return this.http.post(url, data, { headers, responseType: 'text' });
  }

  updatePhotos(token: string, data: any) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const url = this.config.urlService + "api/Producto/UpdateAttrImg/";
    return this.http.post(url, data, { headers, responseType: 'text' });
  }

  deletePhotos(token: string, data: any, idProveedor: number) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const url = this.config.urlService + "api/Producto/DeleteAttrImg/" + idProveedor;
    return this.http.post(url, data, { headers, responseType: 'text' });
  }



}
